import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  root: {
    minHeight: "100vh",
    backgroundImage: `url("http://integration-supplychain.novelis.io/static/media/background.9ed64c9b.jpg")`,
  },
}));
